import { Tooltip } from "@mui/material"
import { GridRenderCellParams } from "@mui/x-data-grid"

interface Props {
    params: GridRenderCellParams
}

export const MyRenderCell = ({ params }: Props) => {
    return (
        <Tooltip title={params.value} >
            <span className="table-cell-trucate">{params.value}</span>
        </Tooltip>
    )
}
